import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  RolePermissionListReq,
  RolePermissionListRes,
  CreateRolePermissionReq,
  ActionRolePermissionRes,
  DeleteRolePermissionReq,
  RefrshPermissionReq,
  RefrshPermissionRes,
} from './types'

export const getRolePermissionListAction = createAsyncAction(
  'ROLE_PERMISSION/GET_ROLE_PERMISSION_LIST_REQ',
  'ROLE_PERMISSION/GET_ROLE_PERMISSION_LIST_SUCCESS',
  'ROLE_PERMISSION/GET_ROLE_PERMISSION_LIST_FAILURE',
)<RolePermissionListReq, RolePermissionListRes, Error>()

export const createRolePermissionAction = createAsyncAction(
  'ROLE_PERMISSION/CREATE_ROLE_PERMISSION_REQ',
  'ROLE_PERMISSION/CREATE_ROLE_PERMISSION_SUCCESS',
  'ROLE_PERMISSION/CREATE_ROLE_PERMISSION_FAILURE',
)<CreateRolePermissionReq, ActionRolePermissionRes, Error>()

export const deleteRolePermissionAction = createAsyncAction(
  'ROLE_PERMISSION/DELETE_ROLE_PERMISSION_REQ',
  'ROLE_PERMISSION/DELETE_ROLE_PERMISSION_SUCCESS',
  'ROLE_PERMISSION/DELETE_ROLE_PERMISSION_FAILURE',
)<DeleteRolePermissionReq, ActionRolePermissionRes, Error>()

export const clearEventAction = createStandardAction('ROLE_PERMISSION/CLEAR_EVENT')<void>()

export const refreshPermissionAction = createAsyncAction(
  'ROLE_PERMISSION/REFRESH_PERMISSION_LIST_REQ',
  'ROLE_PERMISSION/REFRESH_PERMISSION_LIST_SUCCESS',
  'ROLE_PERMISSION/REFRESH_PERMISSION_LIST_FAILURE',
)<RefrshPermissionReq, RefrshPermissionRes, Error>()
